const AUTH_STORAGE_KEYS = [
  'Email',
  'anotaciones',
  'auditoria',
  'busqueda',
  'escaneo',
  'exportacion',
  'idUsuario',
  'importacion',
  'impresion',
  'nombreUsuario',
  'token',
  'vinculacion',
  'workflow'
]

export const clearAuthStorage = () => {
  AUTH_STORAGE_KEYS.forEach(key => {
    localStorage.removeItem(key)
  })
}